import { TimeToLeaveOutlined } from "@mui/icons-material";

import { isObjectEmpty, isPlateCorrect } from "data/functions";
import React from "react";
import FieldBlock from "./FieldBlock";

export function PlateNumberField(props) {
  const [value, setValue] = React.useState(props?.findParams?.plate || "");
  const [helperText, setHelperText] = React.useState("");

  function changeValues(val) {
    props?.setFindParams((e) => {
      return {
        ...e,
        plate: val ? val : null,
      };
    });
    if (isObjectEmpty(val)) {
      setHelperText("");
      // return;
    } else if (!isPlateCorrect(val)) {
      setHelperText("Некорректный гос.номер");
      // return;
    } else setHelperText("");
  }
  return (
    <React.Fragment>
      <FieldBlock
        // error={helperText ? true : false}
        helperText={helperText ? helperText : undefined}
        icon={<TimeToLeaveOutlined />}
        label="plate-number"
        length={12}
        onBlurFunc={changeValues}
        placeholder="Гос.номер а/м.."
        required={props?.required}
        setValue={setValue}
        title="или гос. номер"
        value={value.toLowerCase()}
      />
    </React.Fragment>
  );
}
